import React, { Component } from 'react';
import ReactSelect from 'react-select';
import './select.scss';
import chevDownStoneIcon from '../../../assets/images/chev-down-stone.svg';

/** @import {StylesConfig} from 'react-select' */
/** @import {OptionType, SelectProps} from './SelectTypes' */

const DropdownIndicator = (/** @type {{ innerProps: object }} */ { innerProps }) => {
    return (
        <div className="select__chevron" {...innerProps}>
            <img src={chevDownStoneIcon} alt="chevron icon" />
            <img src={chevDownStoneIcon} alt="chevron icon" />
        </div>
    );
};

const getClassNames = (/** @type {{customClassNames?: string | string[]; hasError?: boolean; isDisabled?: boolean; }} */ { customClassNames = '', hasError = false, isDisabled = false }) => {
    const error = hasError ? ' error' : '';
    const disabled = isDisabled ? ' disabled' : '';
    return ['select alt', customClassNames, error, disabled].join(' ').trim();
};

/** @extends {Component<SelectProps>} */
class Select extends Component {
    render() {
        const { inputRef, customClassNames, hasError, isDisabled, ...restProps } = this.props;

        return (
            <ReactSelect
                {...restProps}
                className={getClassNames({customClassNames, hasError, isDisabled})}
                classNamePrefix="select"
                menuPlacement="auto"
                components={{ DropdownIndicator }}
                ref={inputRef}
            />
        );
    }
}

/** @type { StylesConfig<OptionType, false> } */
const customStyles = {
    option: (provided) => ({
        ...provided,
        fontWeight: 500,
        transition: 'border .2s',
        cursor: 'pointer'
    }),
    menu: (provided) => ({
        ...provided,
        margin: 0,
        borderRadius: '2px',
        border: 'none'
    })
}

/** @extends {Component<SelectProps>} */
export class CustomSelect extends Component {
    render() {
        const { inputRef, customClassNames, hasError, isDisabled, value, ...restProps } = this.props;

        return (
            <ReactSelect
                className={getClassNames(this.props)}
                classNamePrefix='select'
                menuPlacement='auto'
                components={{ DropdownIndicator }}
                menuPortalTarget={document.body}
                styles={customStyles}
                ref={inputRef}
                isDisabled={isDisabled}
                value={value}
                {...restProps}
            />
        );
    }
}

export default Select;